wwdev.popup = {
    init: function () {
        var self = this;
        jQuery('div[wwdev="popup"]').each(function () {
            self.setupPopup(this);
        });
    },
    setupPopup: function (popupElement) {
        var always = false;
        var popup = jQuery(popupElement);
        popup.hide();
        var cookieName = popup.data('cookiename');
        popup.off('.wwdevpopup');
        popup.find('.close').on('click.wwdevpopup', function () {
            popup.hide();
            $.cookie(cookieName, 1, {expires: 1, path: '/'});
        });

        if (!$.cookie(cookieName) || always) {
            setTimeout(function () {
                popup.show();
            }, 2000);
        }
        /*popup.find('.inner').on('click', function(event) {
            event.stopPropagation();
        });*/
    }
};

jQuery(document).ready(function () {
    wwdev.popup.init();
});
